import { render, staticRenderFns } from "./QRUpload.vue?vue&type=template&id=e150e806&scoped=true&"
import script from "./QRUpload.vue?vue&type=script&lang=js&"
export * from "./QRUpload.vue?vue&type=script&lang=js&"
import style0 from "./QRUpload.vue?vue&type=style&index=0&id=e150e806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e150e806",
  null
  
)

export default component.exports